import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './drag.vdt';
import { useDrag } from './useDrag';
import { useConfigContext } from '../config';
export var ColorpickerDrag = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ColorpickerDrag, _Component);
  function ColorpickerDrag() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.drag = useDrag();
    _this.config = useConfigContext();
    return _this;
  }
  return ColorpickerDrag;
}(Component);
ColorpickerDrag.template = template;